import { Injectable } from '@angular/core';
// import { RecordingData, VoiceRecorder } from 'capacitor-voice-recorder';
// import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';

@Injectable({
  providedIn: 'root'
})
export class VoiceRecorderService {

  constructor() { }

  requestAudioRecordingPermission() {
    // return VoiceRecorder.requestAudioRecordingPermission();
  }
}
